import React from 'react';
import { Button } from './Button';
export function BreakPhrase() {
  return <section className="py-24 bg-[#2B211A] text-white text-center relative overflow-hidden" data-id="element-44">
      <div className="absolute inset-0 opacity-10 bg-[url('https://images.unsplash.com/photo-1516483638261-f40af5eb2b17?auto=format&fit=crop&q=80')] bg-cover bg-center mix-blend-overlay" data-id="element-45"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-46">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold italic mb-12 leading-tight text-[#FAF6EE]" data-id="element-47">
          "¿Cuántas clases más vas a<br className="hidden md:block" data-id="element-48" />{' '}
          improvisar el domingo a la noche?"
        </h2>

        <Button href="#pricing" variant="primary" size="lg" className="shadow-2xl shadow-brand-red/30" data-id="element-49">
          👉 BASTA DE BUSCAR — QUIERO MI ITALIANO 360
        </Button>
      </div>
    </section>;
}